

import {  useSelector } from "react-redux";

import {  Box,  Button } from '@mui/material';
import { Link } from "react-router-dom";

// ==============================|| SEARCH INPUT ||============================== //

const SearchSection = () => {
    const { adminLabelsName } = useSelector((state) => state.language);

    return (
        <>
       

            <Box sx={{ display: { xs: 'none',sm:"block", md: 'block' } }}>
            <Link to={`/dashboard`}>
            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{marginLeft:"18px", p: "6px 15px",fontSize:"12px",borderRadius:"8px",background:"#f5d792",color:"#000","&:hover":{background:"#f5d792",color:"#000"} }}
                               
                              >
                              {
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_dashboard").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_dashboard")[0][
                      "value"
                    ] || "lbl_dashboard"
                  : "lbl_dashboard"
                : "lbl_dashboard"
            }
                              </Button>
                              </Link>
                              <Link to={`/properties`}>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{marginLeft:"18px", p: "6px 15px",fontSize:"12px",borderRadius:"8px",background:"#f5d792",color:"#000","&:hover":{background:"#f5d792",color:"#000"} }}
                               
                              >
                              {
              adminLabelsName
                ? adminLabelsName.filter((e) => e.key == "lbl_listed_properties").length > 0
                  ? adminLabelsName.filter((e) => e.key == "lbl_listed_properties")[0][
                      "value"
                    ] || "lbl_listed_properties"
                  : "lbl_listed_properties"
                : "lbl_listed_properties"
            }
                              </Button>
                              </Link>
                              <Link to={`/tenant-list`}>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{marginLeft:"18px", p: "6px 15px",fontSize:"12px",borderRadius:"8px",background:"#f5d792",color:"#000","&:hover":{background:"#f5d792",color:"#000"} }}
                               
                              >
              {
        adminLabelsName
          ? adminLabelsName.filter((e) => e.key == "lbl_tenant_list").length > 0
            ? adminLabelsName.filter((e) => e.key == "lbl_tenant_list")[0][
                "value"
              ] || "lbl_tenant_list"
            : "lbl_tenant_list"
          : "lbl_tenant_list"
      }
                              </Button>
                              </Link>
            </Box>
        </>
    );
};

export default SearchSection;
